import { observable, action, reaction } from 'mobx';

import { api } from '../../services';
import { translationsStore, commonStore } from '..';
import registrationStore from '../registrationStore';

import { fuelTypes, engineSizeTypes, riskPerMaker, vehicleTypes } from './data';

import { stringHelper } from '../../helpers';

const DEFAULT_VEHICLE_TYPE = 'car';

class VehicleInformationStore {
  @observable engineSizes = [];
  @observable fuelSupplyTypes = [];
  @observable riskPerMaker = riskPerMaker;

  @observable makers = [];
  @observable models = [];
  @observable types = [];

  constructor() {
    commonStore.isLoggedIn && this.loadMakers();
    reaction(() => commonStore.isLoggedIn, isLoggedIn => isLoggedIn && this.loadMakers());
    reaction(
      () => translationsStore.currentTranslation,
      translation => {
        this.setEngineSizes();
        this.setFuelSupplyTypes();
      }
    );

    reaction(
      () => registrationStore.vehicleType,
      vehicleType => {
        commonStore.isLoggedIn && this.loadMakers(vehicleType);
      }
    );
  }

  @action
  loadMakers(vehicleType = DEFAULT_VEHICLE_TYPE) {
    return api({ action: vehicleType === 'motorbike' ? 'get motorbike makers' : 'get makers' }).then(makers => (this.makers = makers));
  }

  @action
  loadModels(maker, vehicleType = DEFAULT_VEHICLE_TYPE) {
    if (maker) {
      return api({ action: vehicleType === 'motorbike' ? 'get motorbike models by maker' : 'get models by maker' }, maker).then(models => (this.models = models));
    } else {
      this.models = [];
      return Promise.resolve();
    }
  }

  @action
  loadTypes(model, vehicleType = DEFAULT_VEHICLE_TYPE) {
    if (model) {
      return api({ action: vehicleType === 'motorbike' ? 'get motorbike types by model' : 'get types by model' }, model).then(types => (this.types = types));
    } else {
      this.types = [];
      return Promise.resolve();
    }
  }

  @action
  loadInfocar(infocarAM, vehicleType = 'car') {
    if (infocarAM) {
      return api({ action: vehicleType === 'car' ? 'get infocar' : 'get motorbike infocar' }, infocarAM);
    } else {
      return Promise.resolve();
    }
  }

  @action
  setFuelSupplyTypes() {
    const t = translationsStore.currentTranslation['shared']['carPower'];
    this.fuelSupplyTypes = fuelTypes.map(fuelType => {
      const { type } = fuelType;
      return {
        type,
        name: t[`lbl${stringHelper.normalize(type)}`]
      };
    });
  }

  @action
  setEngineSizes() {
    this.engineSizes = engineSizeTypes.map(engineSizeType => {
      const { type, range } = engineSizeType;
      const t = translationsStore.currentTranslation['shared'];
      return {
        type,
        name: range[0] === 0 ? `${t['lblUntil']} ${range[1]} cc` : range[1] === 0 ? `${t['lblOver']} ${range[0]} cc` : `${range[0]} cc - ${range[1]} cc`
      };
    });
  }

  getFuelTypeByAlias(alias) {
    try {
      let fuelType = fuelTypes.find(fuelType => fuelType.alias.includes(alias.toLowerCase()));
      if (fuelType) {
        return fuelType.type;
      }
    } catch (error) {
      return undefined;
    }
    return undefined;
  }

  getVehicleTypeByAlias(alias) {
    try {
      let vehicleType = vehicleTypes.find(vehicleType => vehicleType.alias.includes(alias.toLowerCase()));
      if (vehicleType) {
        return vehicleType.type;
      }
    } catch (error) {
      return undefined;
    }
    return undefined;
  }

  getEngineTypeBySize(size) {
    let engineSize = engineSizeTypes.find(engineSizeType => {
      return size <= engineSizeType.range[1] || 0 === engineSizeType.range[1];
    });
    if (engineSize) {
      return engineSize.type;
    }
    return undefined;
  }

  getRisk(codiceMarca) {
    let risk = this.riskPerMaker.find(mRisk => parseInt(mRisk.codice, 10) === parseInt(codiceMarca, 10));
    return risk || { type: 'carbeat_protection_lv', risk: 'low' };
  }
}

export default new VehicleInformationStore();



// WEBPACK FOOTER //
// ./src/stores/vehicleInformationStore/index.js